import { render, staticRenderFns } from "./inspeccion.vue?vue&type=template&id=6c8a00d0&scoped=true&"
import script from "./inspeccion.vue?vue&type=script&lang=js&"
export * from "./inspeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a00d0",
  null
  
)

export default component.exports